module.exports = __webpack_public_path__ + "img/home-1.4a2b56f8.jpg";